import React from "react";
import MediaDetails from "../../../media/MediaDetails";

export default function PhotoDetail() {
  return <MediaDetails mediaType="photos" />;
}
